<div class="col">
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="row row-cols-1">
        <div class="col">
          <h4 class="mb-3 p-3 pb-0">{{ 'i_want_to' | translate }}</h4>
        </div>
      </div>
      <span
        class="d-flex"
        [tds-data-loader]="{
          key: 'order-center-actions',
          class: 'col w-100',
          size: 'lg'
        }"
      ></span>
      <ts-carousel
        *ngIf="order_center_actions && order_center_actions.length > 0"
        [tds-data-loader]="{
          key: 'order-center-actions',
          class: 'col w-100',
          size: 'lg'
        }"
        [order_center_actions]="order_center_actions"
        (item_click)="onCarouselItemClick($event)"
      >
      </ts-carousel>
    </div>
  </div>
</div>

<ng-template #countriesList>
  <div class="modal-header">
    <h4 id="ts-country-listbox-label" class="modal-title">
      {{ 'select_country' | translate }}
    </h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="countryModalDismiss()"
    ></button>
  </div>
  <div class="modal-body pt-0">
    <div class="row mb-3">
      <div class="col">
        <span id="ts-country-listbox-description" class="fw-light">
          {{ 'select_primary_country' | translate }}
        </span>
      </div>
    </div>
    <ts-listbox
      aria-labelledby="ts-country-listbox-label"
      aria-describedby="ts-country-listbox-description"
      [options]="countries"
      [selectedOption]="selected_country"
      [maxHeight]="25"
      (selectionEvent)="selectCountry($event)"
    >
      <ng-template #listboxOption let-country>
        <div class="d-flex gap-1 align-items-center">
          {{ country.name | titlecase }}
          <span
            *ngIf="country?.default"
            class="material-icons fs-inherit"
            aria-label="Default country"
          >
            verified
          </span>
        </div>
      </ng-template>
    </ts-listbox>

    <div class="row mt-3">
      <div class="col d-flex justify-content-end">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="onCountryModalBack()">
          {{ 'back' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="countryChoiceValidated()">
          {{ 'continue' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #isLostOrStolen let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ order_action_type.activity_display_name }}</h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-0">
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light">
          {{ 'is_your_device_lost_or_stolen' | translate }}
        </span>
      </div>
    </div>

    <ts-listbox
      class="mb-3"
      [options]="device_lost_options"
      (selectionEvent)="isDeviceStolen($event)"
      aria-labelledby="ts-actiontype-listbox-label"
      aria-describedby="ts-actiontype-listbox-description"
    >
      <ng-template #listboxOption let-lostOrStolen>
        {{ lostOrStolen.name }}
      </ng-template>
    </ts-listbox>
  </div>
</ng-template>
